module.exports = __webpack_public_path__ + "img/HQ-PA10W1CH.694a193f.jpg";